import React from "react";

const SVG = () => (
    <svg className="plus-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.001 40">
        <path
            className="plus"
            d="M17,37V23H3a3,3,0,0,1,0-6H17V3a3,3,0,0,1,6,0V17H37a3,3,0,1,1,0,6H23V37a3,3,0,1,1-6,0Z"
        />
    </svg>
);

export default SVG;
